import {API_SERVERLESS, postFetch} from '~commonApi';

export function apiBackOfficeQuestionNewVersion(jsonBody: any) {
    return postFetch(`${API_SERVERLESS}/backOffice/v3/questionNewVersion`, true, jsonBody);
}

export function apiBackOfficeRemoveTemplateUse(jsonBody: any) {
    return postFetch(`${API_SERVERLESS}/backOffice/v3/removeTemplateUse`, true, jsonBody);
}
